import { Component } from 'react'
import { observer } from 'mobx-react'
import { browserHistory } from 'react-router'

import * as h from 'h'

import Autosuggest from 'react-autosuggest'

import styles from './styles.scss'

@observer(['UiStore', 'ExpertiseStore'])
export default class ExpertiseSearchBar extends Component {
  onSuggestionSelected (_, { suggestion, sectionIndex }) {
    const { ExpertiseStore } = this.props
    if (ExpertiseStore.suggestions[sectionIndex].title === 'faculty') {
      browserHistory.push(`/faculty/${suggestion.id}`)
    } else if (ExpertiseStore.suggestions[sectionIndex].title === 'keywords') {
      ExpertiseStore.selectedKeywordId = suggestion.id
      browserHistory.push({
        pathname: '/expertise',
        query: { search: suggestion.keyword }
      })
    }
  }

  render () {
    const { UiStore, ExpertiseStore, placeholder } = this.props

    const theme = {
      container: styles.container,
      containerOpen: styles.containerOpen,
      input: styles.input,
      suggestionsContainer: styles.suggestionsContainer,
      suggestionsList: styles.suggestionsList,
      suggestion: styles.suggestion,
      suggestionFocused: styles.suggestionFocused,
      sectionContainer: styles.sectionContainer,
      sectionTitle: styles.sectionTitle
    }

    return h.h(Autosuggest, {
      ...h.ca(styles.autosuggest),
      /* Wrapping keywordHints in toJS() fixes prop warnings, but causes
       * a bug with up/down keyboard selection. */
      suggestions: ExpertiseStore.suggestions,
      onSuggestionsFetchRequested: () => {
        ExpertiseStore.fetchKeywordHintsDebounced()
        ExpertiseStore.fetchFacultyHintsDebounced()
      },
      onSuggestionsClearRequested: () => { ExpertiseStore.keywordHints = [] },
      getSuggestionValue: suggestion => suggestion.keyword || suggestion.name,
      renderSuggestion: suggestion => suggestion.keyword || suggestion.name,
      inputProps: {
        placeholder,
        autoFocus: this.props.autoFocus,
        value: UiStore.expertiseFilters.search,
        onChange: (_, { newValue }) => { UiStore.expertiseFilters.search = newValue }
      },
      onSuggestionSelected: ::this.onSuggestionSelected,
      shouldRenderSuggestions: value => value.trim().length >= 3,
      focusFirstSuggestion: true,
      focusInputOnSuggestionClick: false,
      multiSection: true,
      renderSectionTitle: section => h.h4(h.ca(styles.sectionTitle), section.title),
      getSectionSuggestions: section => section.suggestions,
      theme
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/ExpertiseSearchBar/index.js